import React, { useState } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import * as Styles from '../dashboard/staff-notes/StaffNotes.styles';
import { useTranslation } from 'react-i18next';

const StaffDropdown = ({ val, handleCloaseStaffNotes }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Styles.AccountSC>
      <Popup
        closable
        preserve
        open={isOpen}
        hideOnScroll={true}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        popper={{ id: 'popper-container', style: { zIndex: 2000 } }}
        on="click"
        wide
        position="bottom right"
        style={{ padding: 0, right: '2px', left: 'unset' }}
        trigger={<Icon name="ellipsis horizontal" size="large" onClick={() => setIsOpen(!isOpen)} />}
      >
        <Popup.Content>
          <Styles.PopupContentContainer>
            <Styles.Values
              onClick={() => {
                handleCloaseStaffNotes(val.id);
                setIsOpen(false);
              }}
            >
              {t('dashboard.string19')}
            </Styles.Values>
            <Styles.Divider />
          </Styles.PopupContentContainer>
        </Popup.Content>
      </Popup>
    </Styles.AccountSC>
  );
};
export default StaffDropdown;
